import React from 'react';
//import { useAuth0 } from '@auth0/auth0-react';

const AuthErrorDisplay = ({ error }) => {
  const errorMessage = error?.message || "An unknown authentication error occurred.";

  return (
    <div className="content-container access-denied-wrapper">
      <div className="access-denied">
        <h2>Access Denied</h2>
        <p className="highlight">There was a problem logging you in.</p>
        <p><strong>{errorMessage}</strong></p>
      </div>
    </div>
  );
};

export default AuthErrorDisplay;